module.exports = __webpack_public_path__ + "img/u35.f67c7fb6.png";